module.exports = __webpack_public_path__ + "img/dataScreen.9966ec9b.png";